import React from "react";
import Button from "@/components/shared/Button"; // Assuming you already have a Button component

const WorkshopCard = ({ workshop }) => {
  return (
    <div className="relative rounded-2xl border border-gray-200 p-4 text-left shadow-sm transition duration-500 hover:scale-105 hover:shadow-md hover:transition-transform">
      {workshop.video ? (
        <video
          src={workshop.video}
          controls
          className="mb-4 h-96 w-full rounded-xl xl:h-98 2xl:h-124"
          aria-label="Workshop video"
        />
      ) : (
        <img
          src={workshop.image || "/default-image.jpg"} // Fallback image
          alt="Workshop"
          className="mb-4 h-96 w-full rounded-xl object-cover xl:h-98 2xl:h-124"
        />
      )}
      <div className="pb-8">
        <ul className="text-gray mb-6 space-y-4 px-4 text-lg xl:mb-12">
          {workshop.points.map((point, idx) => (
            <li key={idx} className="list-disc text-lg">
              {point}
            </li>
          ))}
        </ul>
      </div>

      <div className="absolute right-0 bottom-4 left-0 mx-auto w-full">
        <Button
          text={workshop.url ? "Apply Now" : "Coming Soon"}
          url={workshop.url}
          blank
          type={workshop.url ? "primary" : "secondary"}
          className={`${!workshop.url && "hover:!text-primary cursor-not-allowed hover:bg-transparent"} mx-auto items-center justify-center xl:w-9/12!`}
        />
      </div>
    </div>
  );
};

export default WorkshopCard;
